import { CreditAlerts } from "../model/creditAlertModel";
import { CreditAlertsError } from "./creditAlerts.reduse";

export type CreditAlertsAction =
  | { type: "SET_CREDIT_ALERTS"; payload: CreditAlerts[] }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "SET_ERROR"; payload: string | null }
  | { type: "SET_TOTAL"; payload: number }
  | {
      type: "SET_TOAST";
      payload: {
        isVisible: boolean;
        message: string;
        type: "success" | "error" | "warning" | "info";
      };
    }
  | { type: "SET_FORM_DATA"; payload: Partial<CreditAlerts> }
  | { type: "RESET_FORM_DATA" }
  | { type: "SET_FORM_ERRORS"; payload: CreditAlertsError }
  | { type: "SET_DELETE_ALERT_DIALOG_OPEN"; payload: boolean }
  | { type: "SET_CREDIT_ALERT_DIALOG_OPEN"; payload: boolean }
  | { type: "SET_DELETING_ALERT_ID"; payload: string | null }
  | { type: "SET_CURRENT_PAGE"; payload: number }
  | { type: "SET_LIMIT"; payload: number }
  | { type: "CLOSE_DELETE_DIALOG"; payload: boolean };

export const setCreditAlerts = (
  payload: CreditAlerts[],
): CreditAlertsAction => ({
  type: "SET_CREDIT_ALERTS",
  payload,
});
export const setLoading = (payload: boolean): CreditAlertsAction => ({
  type: "SET_LOADING",
  payload,
});
export const setCreditAlertDialogOpen = (
  payload: boolean,
): CreditAlertsAction => ({
  type: "SET_CREDIT_ALERT_DIALOG_OPEN",
  payload,
});
export const setFormData = (
  payload: Partial<CreditAlerts>,
): CreditAlertsAction => ({
  type: "SET_FORM_DATA",
  payload,
});
export const setCurrentPage = (payload: number): CreditAlertsAction => ({
  type: "SET_CURRENT_PAGE",
  payload,
});
export const setError = (payload: string | null): CreditAlertsAction => ({
  type: "SET_ERROR",
  payload,
});
export const setToast = (payload: {
  isVisible: boolean;
  message: string;
  type: "success" | "error" | "warning" | "info";
}): CreditAlertsAction => ({
  type: "SET_TOAST",
  payload,
});
export const setDeleteAlertDialogOpen = (
  payload: boolean,
): CreditAlertsAction => ({
  type: "SET_DELETE_ALERT_DIALOG_OPEN",
  payload,
});
export const setDeletingAlertId = (
  payload: string | null,
): CreditAlertsAction => ({
  type: "SET_DELETING_ALERT_ID",
  payload,
});
